export function getAppScrollContainer(): HTMLElement | null {
  if (typeof document === 'undefined') return null;
  return document.querySelector<HTMLElement>('[data-app-scroll-container="true"]');
}

export function getAppScrollTop(): number {
  const scrollContainer = getAppScrollContainer();
  return scrollContainer?.scrollTop ?? window.scrollY;
}

export function setAppScrollTop(top: number): void {
  const scrollContainer = getAppScrollContainer();
  if (scrollContainer) {
    scrollContainer.scrollTop = top;
    return;
  }

  window.scrollTo(0, top);
}
